import React, { useEffect, useState } from "react";
import {
  getBrokerTenants,
  changeTenantStatus,
  activateDemoToTenant,
  deleteFeatureFromTenant,
} from "../../../Services/BrokersApi";
import { getPlane } from "../../../Services/plansApi";
import AddFeatureToDialog from "./AddFeatureDialog";
import EditFeatureDialog from "./EditFeatureDialog";
import ActivateDemoDialog from "./ActivateDemoDialog";
import RenewSystemDialog from "./RenewSystemDialog";
import {
  Container,
  Typography,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  Tooltip,
  TextField,
  MenuItem,
  Chip,
  Card,
  Avatar,
  InputAdornment,
  Stack,
} from "@mui/material";
import {
  Info as InfoIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  FilterList as FilterListIcon,
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
  Add as AddIcon,
  Edit as EditIcon,
  CheckCircle as CheckCircleIcon,
  Autorenew as AutorenewIcon,
  Layers as LayersIcon,
  Delete as DeleteIcon,
  Close as CloseIcon,
  Business as BusinessIcon,
} from "@mui/icons-material";
import { themeColors } from "../../../theme/colors";

const AllVerionspage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [planeMap, setPlaneMap] = useState({});
  const [updatingIds, setUpdatingIds] = useState([]); // قائمة المعرفات الجاري تحديثها

  // states للـ "إضافة ميزة" (مفردتان فقط؛ المنطق في المكوّن المنفصل)
  const [addFeatureDialogOpen, setAddFeatureDialogOpen] = useState(false);
  const [selectedTenantForFeature, setSelectedTenantForFeature] =
    useState(null);
  const [selectedTenantFeatures, setSelectedTenantFeatures] = useState([]);

  // جديدة: حالات حوار التعديل
  const [editFeatureDialogOpen, setEditFeatureDialogOpen] = useState(false);
  const [selectedTenantForEdit, setSelectedTenantForEdit] = useState(null);
  const [selectedTenantActiveFeatures, setSelectedTenantActiveFeatures] =
    useState([]);
  const [editingFeature, setEditingFeature] = useState(null);

  // حالات حوار تفعيل الديمو (مبسطة)
  const [activateDialogOpen, setActivateDialogOpen] = useState(false);
  const [activateTenantId, setActivateTenantId] = useState(null);

  // حالات حوار التجديد
  const [renewDialogOpen, setRenewDialogOpen] = useState(false);
  const [renewTenantId, setRenewTenantId] = useState(null);

  // pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // dialog state for features
  const [featuresDialogOpen, setFeaturesDialogOpen] = useState(false);
  const [dialogPlanes, setDialogPlanes] = useState([]);
  const [featuresDialogTenantId, setFeaturesDialogTenantId] = useState(null); // <-- tenant id for dialog
  const [deletingFeatureId, setDeletingFeatureId] = useState(null); // <-- تتبع الحذف

  // new: search state
  const [searchQuery, setSearchQuery] = useState("");

  // new: date range filters (YYYY-MM-DD)
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");

  // new: demo status filter ('all' | 'demo' | 'active')
  const [demoFilter, setDemoFilter] = useState("all");

  // new: tenant status filter ('all' | 'running' | 'stopped')
  const [statusFilter, setStatusFilter] = useState("all");

  // new: plane/plan filter ('all' or plane id as string)
  const [planeFilter, setPlaneFilter] = useState("all");
  
  // دالة جلب قابلة لإعادة الاستخدام (تُستدعى أيضاً بعد إضافة ميزة)
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("authToken");
      const [tenantsData, planesData] = await Promise.all([
        getBrokerTenants(null, token),
        getPlane(null, token),
      ]);
      setItems(tenantsData || []);

      // استخراج البيانات بشكل صحيح - البيانات في planesData.data.data.palnes
      const planesList =
        planesData?.data?.data?.palnes ||
        planesData?.data?.data?.planes ||
        planesData?.data?.palnes ||
        planesData?.data?.planes ||
        planesData?.palnes ||
        planesData?.planes ||
        [];

      const map = {};
      if (Array.isArray(planesList) && planesList.length > 0) {
        planesList.forEach((p) => {
          if (p && p.id != null) {
            const planeName = p.plane_name ?? p.name ?? p.slug ?? "باقة غير معروفة";
            // تخزين بكل من المفتاح النصي والرقمي
            map[String(p.id)] = planeName;
            map[p.id] = planeName;
          }
        });
      }
      
      setPlaneMap(map);
    } catch (err) {
      console.error("خطأ في fetchData:", err);
      setError(
        (err && (err.message || err.msg || JSON.stringify(err))) || "حدث خطأ"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // reset page when search or date filters change
  useEffect(() => {
    setPage(0);
  }, [searchQuery, startDateFilter, endDateFilter, demoFilter, statusFilter, planeFilter]); // include planeFilter

  // دالة للتبديل (تشغيل/إيقاف) حالة النسخة ثم إعادة جلب البيانات
  const handleToggleTenantStatus = async (tenantId) => {
    if (!tenantId) return;
    const token = localStorage.getItem("authToken");
    setUpdatingIds((s) => [...s, tenantId]);
    try {
      await changeTenantStatus(tenantId, token);
      // بعد النجاح: إعادة جلب العناصر لتحديث الواجهة
      const tokenLocal = localStorage.getItem("authToken");
      const fresh = await getBrokerTenants(null, tokenLocal);
      setItems(fresh || []);
    } catch (err) {
      setError(
        (err && (err.message || err.msg || JSON.stringify(err))) || "حدث خطأ"
      );
    } finally {
      setUpdatingIds((s) => s.filter((id) => id !== tenantId));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openFeaturesDialog = (tenantId = null, planes = []) => {
    setFeaturesDialogTenantId(tenantId);
    setDialogPlanes(planes);
    setFeaturesDialogOpen(true);
  };
  const closeFeaturesDialog = () => {
    setFeaturesDialogOpen(false);
    setDialogPlanes([]);
    setFeaturesDialogTenantId(null);
  };

  // حذف ميزة من tenant (تعريف الدالة الذي كان مفقوداً)
  const handleDeleteFeature = async (featureId) => {
    if (!featuresDialogTenantId || !featureId) return;
    const ok = window.confirm("هل أنت متأكد من حذف هذه الميزة من النسخة نهائيًا؟");
    if (!ok) return;
    setDeletingFeatureId(featureId);
    setError(null);
    try {
      const token = localStorage.getItem("authToken");
      await deleteFeatureFromTenant(featuresDialogTenantId, featureId, token);
      // إزالة الميزة من الحوار الحالي وتحديث البيانات الأساسية
      setDialogPlanes((prev) => (Array.isArray(prev) ? prev.filter((p) => p.id !== featureId) : prev));
      fetchData();
    } catch (err) {
      setError((err && (err.message || err.msg || JSON.stringify(err))) || "خطأ أثناء حذف الميزة");
    } finally {
      setDeletingFeatureId(null);
    }
  };
  
  const openAddFeatureDialog = (tenantId, activeFeatures = []) => {
    setSelectedTenantForFeature(tenantId);
    setSelectedTenantFeatures(
      Array.isArray(activeFeatures) ? activeFeatures : []
    );
    setAddFeatureDialogOpen(true);
  };
  const closeAddFeatureDialog = () => {
    setAddFeatureDialogOpen(false);
    setSelectedTenantForFeature(null);
    setSelectedTenantFeatures([]);
  };

  // جديدة: فتح/إغلاق حوار التعديل
  const openEditFeatureDialog = (
    tenantId,
    activeFeatures = [],
    featureToEdit = null
  ) => {
    setSelectedTenantForEdit(tenantId);
    setSelectedTenantActiveFeatures(
      Array.isArray(activeFeatures) ? activeFeatures : []
    );
    // إن لم يُمرّر featureToEdit نمرّر أول ميزة مفعّلة إن وُجدت
    setEditingFeature(
      featureToEdit ??
        (Array.isArray(activeFeatures) && activeFeatures.length
          ? activeFeatures[0]
          : null)
    );
    setEditFeatureDialogOpen(true);
  };
  const closeEditFeatureDialog = () => {
    setEditFeatureDialogOpen(false);
    setSelectedTenantForEdit(null);
    setSelectedTenantActiveFeatures([]);
    setEditingFeature(null);
  };

  // فتح/إغلاق حوار التفعيل وتهيئة القيم
  const openActivateDialog = (tenantId) => {
    setActivateTenantId(tenantId ?? null);
    setActivateDialogOpen(true);
  };
  const closeActivateDialog = () => {
    setActivateDialogOpen(false);
    setActivateTenantId(null);
  };

  const openRenewDialog = (tenantId) => {
    setRenewTenantId(tenantId ?? null);
    setRenewDialogOpen(true);
  };
  const closeRenewDialog = () => {
    setRenewDialogOpen(false);
    setRenewTenantId(null);
  };

  // prepare filtered items based on searchQuery and date filters
  const query = (searchQuery || "").trim().toLowerCase();
  const hasQuery = !!query;
  const matches = (val) =>
    val != null && String(val).toLowerCase().includes(query);
  const hasDateFilter = !!startDateFilter || !!endDateFilter;
  const hasDemoFilter = demoFilter && demoFilter !== "all";
  const hasStatusFilter = statusFilter && statusFilter !== "all";
  const hasPlaneFilter = planeFilter && planeFilter !== "all";

  const filteredItems = items.filter((it) => {
    const version = it.broker_version || {};
    const tenant = it.tenant || {};
    const planes = it.plane || [];
    const client = it.client || {};
    const featuresSource =
      Array.isArray(tenant?.plane) && tenant.plane.length
        ? tenant.plane
        : Array.isArray(planes)
        ? planes
        : [];

    // 1) تحقق من المطابقة مع نص البحث (أو تجاوز إذا لا يوجد بحث)
    let matchesQuery = true;
    if (hasQuery) {
      matchesQuery =
        matches(client.name) ||
        matches(client.email) ||
        matches(client.phone) ||
        matches(version.notes) ||
        matches(version.cost) ||
        matches(tenant.tenancy_db_name) ||
        matches(tenant.id) ||
        matches(tenant.plane_id);

      // plane name via planeMap
      const planeIdFromTenant =
        tenant && Object.prototype.hasOwnProperty.call(tenant, "plane_id")
          ? tenant.plane_id
          : undefined;
      const planeIdFromPivot =
        Array.isArray(planes) && planes.length
          ? planes.find((pp) => pp?.pivot?.plane_id != null)?.pivot?.plane_id
          : undefined;
      const planeId = planeIdFromTenant ?? planeIdFromPivot;
      const planeName = planeId != null ? (planeMap[planeId] || planeMap[String(planeId)]) : undefined;
      if (matches(planeName)) matchesQuery = true;

      // domains
      const domains = it.domains || [];
      if (Array.isArray(domains) && domains.some((d) => matches(d))) matchesQuery = true;

      // features
      if (
        Array.isArray(featuresSource) &&
        featuresSource.some(
          (f) =>
            matches(f?.name) ||
            matches(f?.key) ||
            matches(f?.pivot?.value) ||
            matches(f?.pivot?.monthly_cost) ||
            matches(f?.pivot?.yearly_cost)
        )
      )
        matchesQuery = true;
    }

    // 2) تحقق من التواريخ (أو تجاوز إذا لا يوجد فلتر تواريخ)
    let matchesDate = true;
    if (hasDateFilter) {
      const fStart = startDateFilter ? Date.parse(startDateFilter) : -Infinity;
      const fEnd = endDateFilter ? Date.parse(endDateFilter) : Infinity;

      const tStartRaw = tenant?.start_date ?? null;
      const tEndRaw = tenant?.end_date ?? null;
      if (!tStartRaw && !tEndRaw) matchesDate = false;
      else {
        const tStart = tStartRaw ? Date.parse(tStartRaw) : null;
        const tEnd = tEndRaw ? Date.parse(tEndRaw) : null;
        const tStartVal = tStart ?? tEnd;
        const tEndVal = tEnd ?? tStart;
        if (tStartVal == null || tEndVal == null) matchesDate = false;
        else matchesDate = tEndVal >= fStart && tStartVal <= fEnd; // overlap
      }
    }

    // 2.b) تحقق من حالة الديمو (أو تجاوز إذا 'all')
    let matchesDemo = true;
    if (hasDemoFilter) {
      const isDemoNum = tenant && tenant.is_demo != null ? Number(tenant.is_demo) : undefined;
      if (demoFilter === "demo") matchesDemo = isDemoNum === 1;
      else if (demoFilter === "active") matchesDemo = isDemoNum !== 1;
    }

    // 2.c) تحقق من حالة النسخة (status) إذا تم تطبيق الفلتر
    let matchesStatus = true;
    if (hasStatusFilter) {
      // tenant.status expected numeric (1 = running, 0 = stopped) — ضبط حسب بياناتك
      const s = tenant && Object.prototype.hasOwnProperty.call(tenant, "status") ? Number(tenant.status) : undefined;
      if (statusFilter === "running") matchesStatus = s === 1;
      else if (statusFilter === "stopped") matchesStatus = s === 0;
    }

    // 2.d) تحقق من باقة النسخة (إذا تم تطبيق فلتر الباقة)
    let matchesPlane = true;
    if (hasPlaneFilter) {
      // استخراج معرف الباقة كما في العرض
      const planeIdFromTenant =
        tenant && Object.prototype.hasOwnProperty.call(tenant, "plane_id")
          ? tenant.plane_id
          : undefined;
      const planeIdFromPivot =
        Array.isArray(planes) && planes.length
          ? planes.find((pp) => pp?.pivot?.plane_id != null)?.pivot?.plane_id
          : undefined;
      const planeId = planeIdFromTenant ?? planeIdFromPivot;
      // مقارنة كسلاسل لضمان المطابقة مع قيمة select
      matchesPlane = planeId != null && String(planeId) === String(planeFilter);
    }

    // النتيجة النهائية تضمن جميع الفلاتر
    return matchesQuery && matchesDate && matchesDemo && matchesStatus && matchesPlane;
  });
  
  const pagedItems = filteredItems.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header Section */}
        <Card
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            background: `linear-gradient(135deg, ${themeColors.info} 0%, #1976D2 100%)`,
            color: "white",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              sx={{
                width: 56,
                height: 56,
                bgcolor: "rgba(255,255,255,0.25)",
                backdropFilter: "blur(10px)",
              }}
            >
              <LayersIcon sx={{ fontSize: 32 }} />
            </Avatar>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                جميع النسخ
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                إدارة ومتابعة نسخ الأنظمة والباقات
              </Typography>
            </Box>
          </Box>
        </Card>

        {/* Filters Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            border: `1px solid ${themeColors.border.light}`,
          }}
        >
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <FilterListIcon sx={{ color: themeColors.info }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              البحث والتصفية
            </Typography>
          </Box>

          <Box display="flex" gap={2} flexWrap="wrap">
            <TextField
              size="small"
              variant="outlined"
              label="بحث شامل"
              placeholder="ابحث بالعميل، البريد، الباقة..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ flex: 1, minWidth: 300 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: themeColors.text.secondary }} />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchQuery("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              size="small"
              label="من تاريخ"
              type="date"
              value={startDateFilter}
              onChange={(e) => setStartDateFilter(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 150 }}
            />

            <TextField
              size="small"
              label="إلى تاريخ"
              type="date"
              value={endDateFilter}
              onChange={(e) => setEndDateFilter(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 150 }}
            />

            <TextField
              select
              size="small"
              label="حالة الديمو"
              value={demoFilter}
              onChange={(e) => setDemoFilter(e.target.value)}
              sx={{ minWidth: 130 }}
            >
              <MenuItem value="all">الكل</MenuItem>
              <MenuItem value="demo">تجريبية</MenuItem>
              <MenuItem value="active">مفعلة</MenuItem>
            </TextField>

            <TextField
              select
              size="small"
              label="حالة النسخة"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              sx={{ minWidth: 130 }}
            >
              <MenuItem value="all">الكل</MenuItem>
              <MenuItem value="running">تعمل</MenuItem>
              <MenuItem value="stopped">لا تعمل</MenuItem>
            </TextField>

            <TextField
              select
              size="small"
              label="الباقة"
              value={planeFilter}
              onChange={(e) => setPlaneFilter(e.target.value)}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="all">الكل</MenuItem>
              {Object.entries(planeMap).map(([id, name]) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {(searchQuery || startDateFilter || endDateFilter || demoFilter !== "all" || statusFilter !== "all" || planeFilter !== "all") && (
            <Box mt={2} display="flex" gap={1} alignItems="center">
              <Typography variant="caption" sx={{ color: themeColors.text.secondary }}>
                النتائج: {filteredItems.length} من {items.length}
              </Typography>
              <Button
                size="small"
                variant="text"
                onClick={() => {
                  setSearchQuery("");
                  setStartDateFilter("");
                  setEndDateFilter("");
                  setDemoFilter("all");
                  setStatusFilter("all");
                  setPlaneFilter("all");
                }}
                sx={{ color: themeColors.info }}
              >
                إعادة تعيين الفلاتر
              </Button>
            </Box>
          )}
        </Paper>

        {loading && (
          <Box display="flex" justifyContent="center" my={8}>
            <CircularProgress size={60} sx={{ color: themeColors.info }} />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            {error}
          </Alert>
        )}

        {!loading && !error && items.length === 0 && (
          <Paper
            elevation={0}
            sx={{
              p: 6,
              textAlign: "center",
              borderRadius: 3,
              border: `2px dashed ${themeColors.border.main}`,
            }}
          >
            <BusinessIcon sx={{ fontSize: 80, color: themeColors.text.light, mb: 2 }} />
            <Typography variant="h6" sx={{ color: themeColors.text.secondary }}>
              لا توجد نسخ حالياً
            </Typography>
          </Paper>
        )}

        {!loading && !error && items.length > 0 && (
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              border: `1px solid ${themeColors.border.light}`,
            }}
          >
            <TableContainer>
              <Table stickyHeader sx={{ direction: "rtl" }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="right" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>العميل</TableCell>
                    <TableCell align="right" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>ملاحظات</TableCell>
                    <TableCell align="right" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>التكلفة</TableCell>
                    <TableCell align="right" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>الباقة</TableCell>
                    <TableCell align="center" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>الحالة</TableCell>
                    <TableCell align="center" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>الميزات</TableCell>
                    <TableCell align="right" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>قاعدة البيانات</TableCell>
                    <TableCell align="center" sx={{ bgcolor: themeColors.background.default, fontWeight: 700, borderBottom: `2px solid ${themeColors.info}` }}>الإجراءات</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pagedItems.map((it, idx) => {
                    const version = it.broker_version || {};
                    const tenant = it.tenant || {};
                    const planes = it.plane || [];
                    const featuresSource = Array.isArray(tenant?.plane) && tenant.plane.length ? tenant.plane : Array.isArray(planes) ? planes : [];
                    const client = it.client || {};
                    const featuresCount = featuresSource.reduce((sum, p) => sum + (p?.pivot ? 1 : 0), 0);
                    const demoStatus = (() => {
                      const isDemo = tenant?.is_demo;
                      const wasDemo = tenant?.was_demo;
                      if (isDemo === 1 && wasDemo === 1) return "تجريبية (حالياً)";
                      if (isDemo === 0 && wasDemo === 1) return "مفعلة (كانت ديمو)";
                      if (isDemo === 1) return "تجريبية";
                      return "مفعلة";
                    })();
                    const isDemoNum = tenant && tenant.is_demo != null ? Number(tenant.is_demo) : undefined;
                    const wasDemoNum = tenant && tenant.was_demo != null ? Number(tenant.was_demo) : undefined;
                    const tenantStatusLabel = tenant && Object.prototype.hasOwnProperty.call(tenant, "status") ? tenant.status === 1 ? "تعمل" : tenant.status === 0 ? "لا تعمل" : String(tenant.status) : "-";
                    const formatDate = (d) => d ? new Date(d).toLocaleDateString("EG") : "-";

                    return (
                      <TableRow
                        key={version.id ?? `${idx}`}
                        sx={{
                          "&:hover": { bgcolor: themeColors.background.hover },
                          "&:nth-of-type(even)": { bgcolor: "rgba(0,0,0,0.02)" },
                        }}
                      >
                        <TableCell align="right">
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: themeColors.text.primary }}>{client.name || "-"}</Typography>
                            <Typography variant="caption" sx={{ color: themeColors.text.secondary }}>{client.email || "-"}</Typography>
                            <Typography variant="caption" display="block" sx={{ color: themeColors.text.secondary }}>📞 {client.phone || "-"}</Typography>
                          </Box>
                        </TableCell>

                        <TableCell align="right" sx={{ fontSize: "0.875rem", color: themeColors.text.secondary }}>{version.notes || "-"}</TableCell>
                        <TableCell align="right">
                          <Chip label={`${version.cost ?? "-"} جنية`} size="small" sx={{ bgcolor: `${themeColors.success}15`, color: themeColors.success, fontWeight: 600 }} />
                        </TableCell>

                        <TableCell align="right">
                          {(() => {
                            const planeIdFromTenant = tenant && Object.prototype.hasOwnProperty.call(tenant, "plane_id") ? tenant.plane_id : undefined;
                            const planeIdFromPivot = Array.isArray(planes) && planes.length ? planes.find((pp) => pp?.pivot?.plane_id != null)?.pivot?.plane_id : undefined;
                            const planeId = planeIdFromTenant ?? planeIdFromPivot;
                            const planeName = planeId != null ? (planeMap[planeId] || planeMap[String(planeId)]) : undefined;
                            return (
                              <Box>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>{planeName || (planeId != null ? `باقة #${planeId}` : "-")}</Typography>
                                <Typography variant="caption" display="block" sx={{ color: themeColors.text.secondary }}>📅 {formatDate(tenant.start_date)} - {formatDate(tenant.end_date)}</Typography>
                              </Box>
                            );
                          })()}
                        </TableCell>

                        <TableCell align="center">
                          <Stack spacing={0.5} alignItems="center">
                            <Chip
                              label={tenantStatusLabel}
                              size="small"
                              icon={tenant.status === 1 ? <PlayArrowIcon /> : <StopIcon />}
                              sx={{
                                bgcolor: tenant.status === 1 ? `${themeColors.success}15` : `${themeColors.error}15`,
                                color: tenant.status === 1 ? themeColors.success : themeColors.error,
                                fontWeight: 600,
                              }}
                            />
                            <Chip
                              label={demoStatus}
                              size="small"
                              variant="outlined"
                              sx={{
                                borderColor: isDemoNum === 1 ? themeColors.warning : themeColors.info,
                                color: isDemoNum === 1 ? themeColors.warning : themeColors.info,
                              }}
                            />
                          </Stack>
                        </TableCell>

                        <TableCell align="center">
                          <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                            <Chip label={featuresCount} size="small" sx={{ bgcolor: themeColors.primary.main, color: "white", fontWeight: 600 }} />
                            <Tooltip title="عرض الميزات">
                              <IconButton size="small" onClick={() => openFeaturesDialog(tenant.id, featuresSource)} sx={{ color: themeColors.info }}>
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>

                        <TableCell align="right">
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.875rem" }}>{tenant.tenancy_db_name || "-"}</Typography>
                            <Typography variant="caption" sx={{ color: themeColors.text.secondary }}>🕐 {tenant.created_at ? new Date(tenant.created_at).toLocaleString("EG") : "-"}</Typography>
                          </Box>
                        </TableCell>

                        <TableCell align="center">
                          {tenant && tenant.id ? (
                            <Stack direction="row" spacing={0.5} justifyContent="center" flexWrap="wrap">
                              <Tooltip title={tenant.status === 1 ? "إيقاف النسخة" : "تشغيل النسخة"}>
                                <IconButton
                                  size="small"
                                  onClick={() => handleToggleTenantStatus(tenant.id)}
                                  disabled={updatingIds.includes(tenant.id)}
                                  sx={{
                                    color: tenant.status === 1 ? themeColors.error : themeColors.success,
                                    "&:hover": { bgcolor: tenant.status === 1 ? `${themeColors.error}15` : `${themeColors.success}15` },
                                  }}
                                >
                                  {updatingIds.includes(tenant.id) ? <CircularProgress size={16} /> : tenant.status === 1 ? <StopIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
                                </IconButton>
                              </Tooltip>

                              {(() => {
                                const activeFeatures = Array.isArray(featuresSource) ? featuresSource.filter((f) => f?.pivot && (f.pivot.value === "1" || f.pivot.value === 1 || f.pivot.value === "true" || f.pivot.value === true)) : [];
                                return (
                                  <>
                                    <Tooltip title="إضافة ميزة">
                                      <IconButton size="small" onClick={() => openAddFeatureDialog(tenant.id, activeFeatures)} sx={{ color: themeColors.success, "&:hover": { bgcolor: `${themeColors.success}15` } }}>
                                        <AddIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title="تعديل ميزة">
                                      <IconButton size="small" onClick={() => openEditFeatureDialog(tenant.id, activeFeatures, activeFeatures[0] ?? null)} sx={{ color: themeColors.primary.main, "&:hover": { bgcolor: `${themeColors.primary.main}15` } }}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    {isDemoNum === 1 && wasDemoNum === 1 && (
                                      <Tooltip title="تفعيل من تجريبية الي نسخة">
                                        <IconButton size="small" onClick={() => openActivateDialog(tenant.id)} sx={{ color: themeColors.warning, "&:hover": { bgcolor: `${themeColors.warning}15` } }}>
                                          <CheckCircleIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}

                                    {isDemoNum === 0 && (
                                      <Tooltip title="تجديد النظام">
                                        <IconButton size="small" onClick={() => openRenewDialog(tenant.id)} sx={{ color: themeColors.info, "&:hover": { bgcolor: `${themeColors.info}15` } }}>
                                          <AutorenewIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </>
                                );
                              })()}
                            </Stack>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Features Dialog */}
            <Dialog
              open={featuresDialogOpen}
              onClose={closeFeaturesDialog}
              fullWidth
              maxWidth="sm"
              PaperProps={{ sx: { borderRadius: 3 } }}
            >
              <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pb: 2, borderBottom: `1px solid ${themeColors.border.light}` }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <InfoIcon sx={{ color: themeColors.info }} />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>تفاصيل الميزات</Typography>
                  <Chip label={dialogPlanes.length} size="small" sx={{ bgcolor: themeColors.info, color: "white" }} />
                </Box>
                <IconButton size="small" onClick={closeFeaturesDialog}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ pt: 2 }}>
                {dialogPlanes.length === 0 ? (
                  <Alert severity="info" sx={{ borderRadius: 2 }}>لا توجد ميزات</Alert>
                ) : (
                  <List sx={{ p: 0 }}>
                    {dialogPlanes.map((p, idx) => (
                      <React.Fragment key={p.id}>
                        <ListItem
                          sx={{
                            px: 0,
                            py: 2,
                            "&:hover": { bgcolor: themeColors.background.hover },
                          }}
                          secondaryAction={
                            <Tooltip title="حذف الميزة">
                              <IconButton
                                edge="end"
                                size="small"
                                onClick={() => handleDeleteFeature(p.id)}
                                disabled={deletingFeatureId === p.id}
                                sx={{ color: themeColors.error, "&:hover": { bgcolor: `${themeColors.error}15` } }}
                              >
                                {deletingFeatureId === p.id ? <CircularProgress size={16} /> : <DeleteIcon fontSize="small" />}
                              </IconButton>
                            </Tooltip>
                          }
                        >
                          <ListItemText
                            primary={<Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{p.name}</Typography>}
                            secondary={
                              <Box component="span">
                                <Typography variant="caption" display="block">القيمة: {p.pivot?.value ?? "-"}</Typography>
                                <Typography variant="caption" display="block">شهري: {p.pivot?.monthly_cost ?? "-"} • سنوي: {p.pivot?.yearly_cost ?? "-"}</Typography>
                              </Box>
                            }
                          />
                        </ListItem>
                        {idx < dialogPlanes.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </DialogContent>
              <DialogActions sx={{ p: 2, borderTop: `1px solid ${themeColors.border.light}` }}>
                <Button onClick={closeFeaturesDialog} variant="outlined" sx={{ borderRadius: 2 }}>إغلاق</Button>
              </DialogActions>
            </Dialog>

            {/* AddFeatureDialog كمكوّن منفصل */}
            <AddFeatureToDialog
              open={addFeatureDialogOpen}
              tenantId={selectedTenantForFeature}
              activeFeatures={selectedTenantFeatures} // ← تمرير الميزات المفعّلة
              onClose={closeAddFeatureDialog}
              onFeatureAdded={() => {
                // بعد إضافة ميزة: إعادة جلب البيانات
                fetchData();
              }}
            />

            {/* Dialog منفصل لتعديل الميزة */}
            <EditFeatureDialog
              open={editFeatureDialogOpen}
              tenantId={selectedTenantForEdit}
              activeFeatures={selectedTenantActiveFeatures}
              feature={editingFeature}
              onClose={closeEditFeatureDialog}
              onUpdated={() => {
                fetchData();
                closeEditFeatureDialog();
              }}
            />

            {/* ActivateDemoDialog كمكوّن منفصل */}
            <ActivateDemoDialog
              open={activateDialogOpen}
              tenantId={activateTenantId}
              onClose={closeActivateDialog}
              onActivated={() => {
                fetchData();
                closeActivateDialog();
              }}
            />

            {/* RenewSystemDialog كمكوّن منفصل */}
            <RenewSystemDialog
              open={renewDialogOpen}
              tenantId={renewTenantId}
              onClose={closeRenewDialog}
              onRenewed={() => {
                fetchData();
                closeRenewDialog();
              }}
            />

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={filteredItems.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="عدد الصفوف:"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} من ${count}`}
              sx={{ borderTop: `1px solid ${themeColors.border.light}`, bgcolor: themeColors.background.default }}
            />
          </Paper>
        )}
      </Container>
    </Box>
  );
};

export default AllVerionspage;
